<template>
  <div style="margin: 10px; text-align: center;">
    <h2>hello world</h2>
  </div>
</template>
<script>
  export default {
    name: 'demo-hello-world'
  }
</script>



// WEBPACK FOOTER //
// src/custom/components/demo/demo-hello-world.vue